import { useQuery } from "@apollo/client";

import { Maybe } from "types/generated";

import { GET_BITBUCKET_DATA_CENTER_INTEGRATION } from "./gql";

const useGetBitbucketDataCenterIntegration = (id: Maybe<string>) => {
  const { data, loading, error } = useQuery(GET_BITBUCKET_DATA_CENTER_INTEGRATION, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.bitbucketDatacenterIntegration,
    isPageLoading: loading && !data?.bitbucketDatacenterIntegration,
    error,
  };
};

export default useGetBitbucketDataCenterIntegration;
